import './Header.css';

import type { FunctionComponent } from 'react';
import { useNavigate } from 'react-router';

import { Button, type ButtonProps } from '../Button';
import { Divider } from '../Divider/Divider.component.tsx';
import { Logo } from '../Logo/Logo.component.tsx';

interface HeaderProps {
  buttonProps?: ButtonProps | undefined;
}

export const Header: FunctionComponent<HeaderProps> = ({ buttonProps }) => {
  const navigate = useNavigate();
  const goToPatientList = () => {
    void navigate('/patient-list', { replace: true });
  };

  return (
    <header className="header">
      <div className="header-content">
        <Logo onClick={goToPatientList} />
        <div>{buttonProps && <Button {...buttonProps} />}</div>
      </div>
      <Divider />
    </header>
  );
};
